module.exports = "<my-top-navigation class=\"my-top-navigation\"></my-top-navigation>\n<main>\n    <my-page-content></my-page-content>\n</main>\n<my-footer class=\"my-footer\"></my-footer>\n\n<!-- Required for NgbModal -->\n<template ngbModalContainer></template>\n\n<!-- Required for Ng2Toasty -->\n<ng2-toasty [position]=\"'top-right'\"></ng2-toasty>\n\n<!-- Required fo Download Links via AJAX -->\n<a id=\"download-link\" style=\"display: none\">&nbsp;</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 1457
// module chunks = 0